import { Helmet } from "react-helmet-async";
import Banner from "../components/Banner";
import PlatformInfo from "../components/home/PlatformInfo";
import AltPlatformInfo from "../components/home/AltPlatformInfo";
import RegisterForm from "../components/home/RegisterForm";
import UpcomingEvents from "../components/home/UpcomingEvents";
import AboutUs from "../components/home/AboutUs";
import ImageStaggerGrid from "../components/home/Images";
export default function Home() {
  return (
    <>
      <Helmet>
        <title>Home | MyApp</title>
      </Helmet>
      
      <Banner />
    <AboutUs />
    <PlatformInfo />
    <UpcomingEvents />
    <RegisterForm />
    <ImageStaggerGrid />
    <AltPlatformInfo />
    
    </>
  );
}
